<template>
  <!-- 缴费入口 -->
  <div class="payEnterance">
    <div class="pay-top">{{ title }}</div>
    <div class="pay-center">
      <div
        class="payItem"
        v-for="(item, index) in payList"
        :key="index"
        :class="payIndex === index ? 'cur' : ''"
        @click="clickItem(index)"
      >
        <div class="payItem-icon"></div>
        <div class="payItem-title">{{ item.title }}</div>
        <div class="payItem-price">
          <span style="font-size:18px">￥</span>
          <span>{{ item.price }}</span>
        </div>
        <div class="payItem-summary f-c j-c">
          <div>{{ item.summary }}</div>
          <div style="color:#9C9EAB">请备注姓名单位手机号</div>
        </div>
      </div>
    </div>
    <div class="pay-bottom">
<!--      <div class="pay-bottom-btn" @click="clickToPay">点击缴费</div>-->
        <div class="pay-bottom-btn">请线下缴费</div>
    </div>
    <div class="scanCode" v-show="showCode">
      <div class="close" @click="showCode = false"></div>
      <!-- <i class="el-icon-circle-close" @click="showCode = false"></i> -->
      <div class="code">
        <!-- <div class="code-title">微信支付</div> -->
        <!-- <div class="code-pic-info-box">
          <div class="code-pic-info">
            <div class="code-pic"></div>
            <div class="code-pic-tip">
              <div class="code-pic-tip-txt">
                <p>请使用微信扫一扫</p>
                <p>扫描二维码支付</p>
              </div>
            </div>
          </div>
          <div class="code-find-saoma"></div>
        </div>-->
        <div class="code-pic-info-box">
          <div class="code-out-image">
            <div class="code-image"></div>
          </div>
        </div>
        <div class="code-warn">注意：交费时，请输入对应的金额，备注清楚姓名、单位、手机号缴费后注意保存缴费凭证，缴费成功后关闭本页面即可</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {
      title: "建设工程专业、经济系列、工艺美术系列职称评审缴费",
      payList: [
        {
          title: "助理工程师\n助理工艺美术师",
          price: "100",
          summary: new Date().getFullYear() + "年现已开始报名缴费"
        },
        {
          title: "工程师\n工艺美术师",
          price: "200",
          summary: new Date().getFullYear() + "年现已开始报名缴费"
        },
        {
          title: "高级工程师\n高级经济师\n高级工艺美术师",
          price: "300",
          summary: new Date().getFullYear() + "年现已开始报名缴费"
        },
        {
          title: "正高级工程师\n正高级经济师\n正高级工艺美术师",
          price: "300",
          summary: new Date().getFullYear() + "年现已开始报名缴费"
        }
      ],
      payIndex: null,
      showCode: false // 是否展示二维码
    };
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {},
  methods: {
    clickItem(index) {
      this.payIndex = index;
    },
    // 点击缴费
    clickToPay() {
      if (this.payIndex == null) {
        this.$message({
          showClose: true,
          message: "请选择一项进行缴费",
          type: "warning"
        });
      } else {
        this.showCode = true;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.payEnterance {
  width: 1450px;
  height: 870px;
  box-shadow: 0 0 6px #99999959;
  margin: 0 auto;
  margin-top: 40px;
  margin-bottom: 40px;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  position: relative;

  .pay-top {
    width: 100%;
    height: 114px;
    line-height: 114px;
    text-align: center;
    font-size: 30px;
    font-weight: 600;
    color: #fff;
    background-color: #2d50a1;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
  }

  .pay-center {
    width: 100%;
    flex: 1;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-around;
    align-items: center;

    .payItem {
      width: 250px;
      height: 355px;
      border-radius: 16px;
      box-shadow: 0 0 6px #999999cc;
      border: 1px solid #999999cc;
      position: relative;
      display: flex;
      flex-flow: column nowrap;
      justify-content: space-around;
      align-items: center;
      white-space: pre-wrap;
      text-align: center;
      cursor: pointer;

      .payItem-icon {
        position: absolute;
        width: 65px;
        height: 6px;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        border: 0px solid transparent;
        border-left: 5px solid transparent;
        border-top: 5px solid #fd5a0b;
        border-right: 5px solid transparent;
      }

      .payItem-title {
        font-size: 24px;
        font-weight: 600;
        height: 93px;
      }

      .payItem-price {
        font-size: 50px;
        font-weight: 500;
        color: #fd5a0b;
        display: flex;
        justify-content: center;
        align-items: baseline;
      }

      .payItem-summary {
        border-top: 1px solid #9c9eab47;
        height: 60px;
        & > div {
          margin-top: 5px;
        }
      }
    }

    .cur {
      border: 1px solid #fd5a0b;
    }
  }

  .pay-bottom {
    width: 100%;
    height: 200px;
    display: flex;
    justify-content: center;

    .pay-bottom-btn {
      width: 155px;
      height: 45px;
      line-height: 45px;
      text-align: center;
      background-color: #fd5a0b;
      font-size: 24px;
      color: #fff;
      border-radius: 25px;
      cursor: pointer;
    }
  }

  .scanCode {
    position: absolute;
    width: 1450px;
    height: 756px;
    top: 114px;
    border-bottom-left-radius: 16px;
    border-bottom-right-radius: 16px;
    background-color: #00000059;

    .code {
      width: 800px;
      height: 600px;
      margin: 0 auto;
      margin-top: 70px;

      .code-title {
        font-family: "Arial Negreta", "Arial Normal", "Arial", sans-serif;
        font-weight: 700;
        font-style: normal;
        color: #00bf35;
        text-align: center;
        margin-top: 26px;
        margin-bottom: 0px;
      }

      .code-pic-info-box {
        // padding-top: 40px;
        display: flex;
        justify-content: center;

        .code-out-image {
          background: url(../../assets/publicService/talentService/payOutImage.jpg)
            no-repeat center center/100% 100%;
          width: 300px;
          height: 533.33px;
          box-shadow: 0 0 3px #000;
          display: flex;
          justify-content: center;
          align-items: center;
          .code-image {
            background: url("../../assets/publicService/talentService/code.png")
              no-repeat center center/100% 100%;
            width: 170px;
            height: 170px;
            margin-top: 34px;
          }
        }

        // .code-pic-info {
        //   .code-pic {
        //     background: url("../../assets/publicService/talentService/code.png")
        //       no-repeat center center/100% 100%;
        //     width: 300px;
        //     height: 300px;
        //   }
        //   .code-pic-tip {
        //     margin: 0 auto;
        //     background-color: #f67372;

        //     .code-pic-tip-txt {
        //       margin: auto;
        //       width: 140px;
        //       color: #fff;
        //       margin-top: 15px;
        //       margin-bottom: 15px;
        //     }
        //   }
        // }
        // .code-find-saoma {
        //   background: url("../../assets/publicService/talentService/saoma.png")
        //     no-repeat center center/100% 100%;
        //   width: 300px;
        //   height: 300px;
        // }
      }
      .code-warn {
        font-size: 16px;
        color: #fff;
        text-align: center;
        width: 450px;
        line-height: 1.5;
        font-weight: bold;
        margin: 15px auto;
      }
    }

    .close {
      width: 25px;
      height: 25px;
      background: url("../../assets/publicService/talentService/close.png")
        no-repeat center center/100% 100%;
      position: absolute;
      right: 20px;
      top: 20px;
      cursor: pointer;
    }
  }

  /deep/ .el-icon-circle-close:before {
    font-size: 32px;
    position: absolute;
    right: 20px;
    top: 20px;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/talentServices/payEnterance.vue